import React from 'react'
import { Card } from '@surecompanies/core_components'
import { CurrencyFormatter } from 'helpers/formatters'
import type { PaymentCase } from '../PaymentDetailModal/PaymentDetailModal.types'
import { SectionCardWrapper, SectionTitle } from './PaymentDetailModal.styles'
import { DetailFieldGrid } from './DetailFieldGrid'
import { NOT_AVAILABLE } from '../Utils/types'
import { convertFromISODate } from 'helpers/datetime'

const currencyFormatter = new CurrencyFormatter()

const paymentInfoCardStyle = {
  backgroundColor: '#e8f4fc',
  marginBottom: 0,
  border: '1px solid #dfe3e8',
} as const

interface BenefitInformationSectionProps {
  paymentCase: PaymentCase
  onCopy: (text: string) => void
}

export function BenefitInformationSection({
  paymentCase,
  onCopy,
}: BenefitInformationSectionProps) {
  const benefitId = paymentCase.benefitId || NOT_AVAILABLE
  // const billingId = paymentCase.billingId || NOT_AVAILABLE
  const calculatedPlanCostLabel = paymentCase.expectedCost
    ? currencyFormatter.format(Number(paymentCase.expectedCost))
    : NOT_AVAILABLE
  const confirmedCarrierPlanCostLabel = paymentCase.actualCost
    ? currencyFormatter.format(Number(paymentCase.actualCost))
    : NOT_AVAILABLE

  const benefitEffectiveDate = paymentCase.benefit?.benefitEffectiveDate
    ? convertFromISODate(
        paymentCase.benefit?.benefitEffectiveDate,
        undefined,
        'MM-DD-YYYY'
      )
    : NOT_AVAILABLE
  const benefitEndDate = paymentCase.benefit?.benefitEndDate
    ? convertFromISODate(
        paymentCase.benefit?.benefitEndDate,
        undefined,
        'MM-DD-YYYY'
      )
    : NOT_AVAILABLE
  return (
    <SectionCardWrapper>
      <Card style={paymentInfoCardStyle}>
        <SectionTitle>Benefit Information</SectionTitle>
        <DetailFieldGrid
          onCopy={onCopy}
          fields={[
            {
              title: 'Benefit Name',
              value: paymentCase.planName || NOT_AVAILABLE,
            },
            {
              title: 'Benefit ID',
              value: benefitId,
              isCopy: true,
              copyValue: benefitId || undefined,
              tooltipTitle: benefitId,
              style: { gridColumn: 'span 2' },
            },
            {
              title: 'Carrier Name',
              value: paymentCase.carrierName || NOT_AVAILABLE,
            },
            {
              title: 'Group ID',
              value: paymentCase.groupId || NOT_AVAILABLE,
              isCopy: Boolean(paymentCase.groupId),
              copyValue: paymentCase.groupId || undefined,
              style: { gridColumn: 'span 2' },
            },
            {
              title: 'Benefit Effective Date (MM-DD-YYYY)',
              value: benefitEffectiveDate,
              isCopy: benefitEffectiveDate !== NOT_AVAILABLE,
              copyValue: benefitEffectiveDate || undefined,
            },
            {
              title: 'Benefit End Date (MM-DD-YYYY)',
              value: benefitEndDate,
              isCopy: benefitEndDate !== NOT_AVAILABLE,
              copyValue: benefitEndDate || undefined,
              style: { gridColumn: 'span 2' },
            },
            {
              title: 'Calculated Plan Cost',
              value: calculatedPlanCostLabel,
              isCopy: calculatedPlanCostLabel !== NOT_AVAILABLE,
              copyValue: paymentCase.expectedCost?.toString() || undefined,
            },
            {
              title: 'Confirmed Carrier Plan Cost',
              value: confirmedCarrierPlanCostLabel,
              isCopy: confirmedCarrierPlanCostLabel !== NOT_AVAILABLE,
              copyValue: paymentCase.actualCost?.toString() || undefined,
            },
          ]}
        />
      </Card>
    </SectionCardWrapper>
  )
}
